import Component from '../abstracts/Component';
import {Zero, Components} from 'Zero';
import {ZFilters} from "StoreLocatorSubcomponents/sl_filters.js";
import {ZMap} from "StoreLocatorSubcomponents/sl_map.js";
import {ZResults} from "StoreLocatorSubcomponents/sl_results.js";
import {ZResultsCounter} from "StoreLocatorSubcomponents/sl_results_counter.js";
import {ZSearch} from "StoreLocatorSubcomponents/sl_search.js";
import {ZStoreLocator} from "StoreLocatorSubcomponents/sl_storelocator.js";

export default class StoreLocatorComponent extends Component {
  get SELECTORS() {
    return {
      filterTrigger: '.sl__side-col__filters__trigger',
      filtersList: '.we_sl-filter-facet',
      filterReset: '.sl__side-col__filters__list-content-footer'
    };
  }

  bindEvents() {
    const ctx = this;
    this.$on('click', ({event}) => {
      const filters = document.querySelectorAll(ctx.SELECTORS.filtersList);
      filters.forEach(filter => {
        let checkbox = filter.getElementsByTagName('input')[0];
        checkbox.checked = false;
      });
    }, 'body', ctx.SELECTORS.filterReset);
  }

  render() {
    super.render();
    this.bindEvents();
    let _this = this;

    window.InitGoogle = function () {};
    const googleApiKey = $("#googleApi").data("key");
    const googleLanguage = $("#googleApi").data("language");

    const apiUrl = `https://maps.googleapis.com/maps/api/js?v=3.36&key=${googleApiKey}&libraries=places,geometry&callback=InitGoogle&language=${googleLanguage}`;

    this.moduleLoader.loadExternalScript(apiUrl).then(() => {
      window.Zero = Zero;

      Components.create('ZStoreLocator', ZStoreLocator);
      Components.create('ZMap', ZMap);
      Components.create('ZSearch', ZSearch);
      Components.create('ZResults', ZResults);
      Components.create('ZFilters', ZFilters);
      Components.create('ZResultsCounter', ZResultsCounter);

      window.GEO_JSON = {};

      Zero.start( {} );
    });
  }
}
